// SCREEN_DETAIL (VTuber詳細) で使うAPI
// VTuber本体や動画の取得、タグの却下・削除は commonApi にある。
export const postAttributes = async (userId, vtuberId, attributes) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/attributes`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, vtuberId, attributes }),
    },
  );

  if (!response.ok) {
    throw new Error("属性の投稿に失敗しました");
  }
};

// POST /vtubers/:id/arrow
// is_arrow を更新する(承認/非表示化)。ADMIN_USER_ID のみ実行可能
export const updateVtuberArrow = async (vtuberId, isArrow) => {
  const userId = localStorage.getItem("user");

  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/vtubers/${vtuberId}/arrow`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, isArrow }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "表示設定の更新に失敗しました");
  }
};

// POST /vtubers/:id/visiable
// is_visiable を更新する(本人ページとして公開するか)。ADMIN_USER_ID のみ実行可能
export const updateVtuberVisiable = async (vtuberId, isVisiable) => {
  const userId = localStorage.getItem("user");

  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/vtubers/${vtuberId}/visiable`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, isVisiable }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "表示設定の更新に失敗しました");
  }
};
